import { CustomerColumn } from './customer-column.enum';

export enum PartnerCustomerColumn {
  Name = 'name',
  Configured = 'configured',
  BetaFeaturesEnabled = 'betaFeaturesEnabled',
  HostLicenses = 'hostLicenses',
  Actions = 'actions',
}

export namespace PartnerCustomerColumn {
  export const allColumns: string[] = [
    PartnerCustomerColumn.Name,
    PartnerCustomerColumn.Configured,
    PartnerCustomerColumn.BetaFeaturesEnabled,
    PartnerCustomerColumn.HostLicenses,
    PartnerCustomerColumn.Actions,
  ];

  export const displayedColumns: string[] = [
    PartnerCustomerColumn.Name,
    PartnerCustomerColumn.Configured,
    PartnerCustomerColumn.BetaFeaturesEnabled,
    PartnerCustomerColumn.HostLicenses,
    PartnerCustomerColumn.Actions,
  ];

  export const translateKey = (column: string): string => {
    switch (column) {
      case PartnerCustomerColumn.Name:
        return 'customers.columns.name';
      case PartnerCustomerColumn.Configured:
        return 'customers.columns.configured';
      case PartnerCustomerColumn.BetaFeaturesEnabled:
        return 'customers.columns.betaFeaturesEnabled';
      case PartnerCustomerColumn.HostLicenses:
        return 'customers.columns.hostLicenses.label';
      case PartnerCustomerColumn.Actions:
        return 'customers.columns.actions';
      default:
        return '';
    }
  };
  export const tooltipTranslateKey = (column: string): string => {
    switch (column) {
      case PartnerCustomerColumn.HostLicenses:
        return 'customers.columns.hostLicenses.tooltip';
      default:
        return '';
    }
  };

  export const sortField = (column: string): string => {
    switch (column) {
      case PartnerCustomerColumn.Name:
        return 'name';
      default:
        return '';
    }
  };

  export const filter = (columns: string[]): string[] => {
    return columns.filter((column) => allColumns.includes(column));
  };
}
